import { Auth } from '@aws-amplify/auth';
import { Amplify } from 'aws-amplify'
import { config } from '../config-amplify'
import { CognitoUser } from '@aws-amplify/auth'
import { CognitoIdentityServiceProvider } from "aws-sdk";

Amplify.configure({
  Auth: {
    mandatorySignIn: false,
    region: config.REGION,
    userPoolId: process.env.REACT_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_CLIENT_ID,
    //identityPoolId: config.IDENTITY_POOL_ID,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
})

const cognito = new CognitoIdentityServiceProvider({
  region: config.REGION, // e.g. 'us-west-2'
  accessKeyId: process.env.REACT_APP_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_SECRET_KEY,
  // You might also need to provide credentials if not using default ones
  // accessKeyId: 'YOUR_ACCESS_KEY',
  // secretAccessKey: 'YOUR_SECRET_KEY',
});

export class AuthService {
  public async login(userName: string, password: string) {
    const user = (await Auth.signIn(userName, password)) as CognitoUser
    return user
  }

  public async signUp(
    email: string,
    password: string,
    name: string,
    tenant_id: string,
    user_plan: string,
    userTenant : boolean = true,
    user_role = ""
  ) {
    let date = new Date()
    date.setDate(date.getDate() + 7);

    if (userTenant) {
      const user = await Auth.signUp({
        username: email,
        password,
        attributes: {
          email,
          'custom:first_time': 'true',
          'custom:user_plan': user_plan,
          'custom:real_name': name,
          'custom:subscription_end': date.toISOString().replace(/T.+/, ''),
          'custom:subscription_type': 'MONTHLY',
          'custom:tenant_id': tenant_id,
          'custom:user_role': 'master',
          // address,
          // name,
          // phone_number: "+583123",
          // "custom:user_plan": "emprendedor",
          // "custom:real_name": name,
        },
      })
      return user
    }

    const user = await Auth.signUp({
      username: email,
      password,
      attributes: {
        email,
        'custom:first_time': 'true',
        'custom:real_name': name,
        'custom:tenant_id': tenant_id,
        'custom:user_plan': user_plan,
        'custom:user_role': user_role
      },
    })
    return user
  }

  public async confirmSignUp(email: string, code: string) {
    const user = await Auth.confirmSignUp(email, code)
    return user
  }

  public async changeFirstTime() : Promise<any> {
    const user = await Auth.currentAuthenticatedUser()
    const result = await Auth.updateUserAttributes(user, {
      'custom:first_time': 'false',
    })

    if (user.attributes['custom:user_role'] === 'master') {
      const email = `seniat_${user.username}`
      const subscription_end = user.attributes['custom:subscription_end']
      const user_plan = user.attributes['custom:user_plan']
      const tenant_id = user.attributes['custom:tenant_id']

      const resp = await Auth.signUp({
        username: email,
        password: "7891Seniat!Ab",
        attributes: { 
          email,
          'custom:first_time': 'true', 
          'custom:user_plan': user_plan,
          'custom:real_name': "Seniat",
          'custom:subscription_end': subscription_end,
          'custom:subscription_type': 'MONTHLY',
          'custom:tenant_id': tenant_id,
          'custom:user_role': 'seniat',
        },
      })

      return resp
    }
  }

  public async changeUserSubscriptionData(user_plan : string, date : Date, subscription_type : string) : Promise<void> {
    const user = await Auth.currentAuthenticatedUser()
    const result = await Auth.updateUserAttributes(user, {
      'custom:user_plan': user_plan,
      'custom:subscription_end': date.toISOString().replace(/T.+/, ''),
      'custom:subscription_type': subscription_type,
    })
  }

  public async refreshToken(): Promise<string> {
    const currentSession = await Auth.currentSession()
    /** Este método retorna de una vez el nuevo token */
    return currentSession.getIdToken().getJwtToken()
  }

  public async forgotPassword (username) : Promise<any> {
    await Auth.forgotPassword(username)
  }

  public async forgotPasswordSubmit (username, code, password) {
    await Auth.forgotPasswordSubmit(username, code, password)
  }

  public async changePassword (oldPassword: string, newPassword: string) : Promise<any> {
    let user = await Auth.currentAuthenticatedUser()
    await Auth.changePassword(user, oldPassword, newPassword)
  }

  // public async getAWSTemporaryCreds(user: CognitoUser) {
  //   const cognitoIdentityPool = `cognito-idp.${config.REGION}.amazonaws.com/${config.USER_POOL_ID}`;
  //   AWS.config.credentials = new AWS.CognitoIdentityCredentials(
  //     {
  //       IdentityPoolId: config.IDENTITY_POOL_ID,
  //       Logins: {
  //         [cognitoIdentityPool]: user
  //           .getSignInUserSession()!
  //           .getIdToken()
  //           .getJwtToken(),
  //       },
  //     },
  //     {
  //       region: config.REGION,
  //     }
  //   );
  //   await this.refreshCredentials();
  // }

  // private async refreshCredentials(): Promise<void> {
  //   return new Promise((resolve, reject) => {
  //     (AWS.config.credentials as Credentials).refresh((err) => {
  //       if (err) {
  //         reject(err);
  //       } else {
  //         resolve();
  //       }
  //     });
  //   });
  // }

  public async userExists(email: string): Promise<boolean> {
    const userPoolId = process.env.REACT_APP_USER_POOL_ID;

    const params = {
        UserPoolId: userPoolId!,
        Filter: `email = "${email}"`,
        Limit: 1
    };

    try {
        const response = await cognito.listUsers(params).promise();

        return (response.Users && response.Users.length > 0) || false;
    } catch (error) {
        console.error("Error checking user existence:", error);
        return false;
    }
}

}
